<script lang="ts" setup>
// このコンポーネントは
//  ・Androidの戻るボタン
//  ・iOSのback・forward
// を無効化することができます。
// 特定の条件下で有効化・無効化したい場合はv-ifで制御できます。
import { onBeforeUnmount, onMounted } from "vue";

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    WkWebView: any;
  }
}

onBeforeUnmount(() => {
  document.removeEventListener("backbutton", onBackKeyDown, false);
  if (!window.WkWebView) return;
  window.WkWebView.allowsBackForwardNavigationGestures(true);
});

onMounted(() => {
  document.addEventListener("backbutton", onBackKeyDown, false);
  if (!window.WkWebView) return;
  window.WkWebView.allowsBackForwardNavigationGestures(false);
});

function onBackKeyDown() {
  return false;
}
</script>

<template>
  <div style="display: none;" />
</template>
